import default_state from "./default_state";

export const RESET_STATE = (state) => {
    Object.assign(state, default_state())
}

export const SET_MODAL = (state, value) => {
    state.show_modal = value
}

export const SET_MESSAGE = (state, value) => {
    state.message = value
}

export const SET_SCHEDULER_MODAL = (state, value) => {
    state.show_scheduler_modal = value
}

export const SET_SCHEDULER_EDIT_MODAL = (state, value) => {
    state.show_scheduler_edit_modal = value
}

export const SET_SCHEDULER_EDITING_ID = (state, value) => {
    state.edit_scheduler_id = value
}

export const SET_NAME = (state, value) => {
    state.name = value
}

export const SET_QUERY = (state, value) => {
    state.query = value
}

export const SET_CREATE_COHORT = (state, value) => {
    state.create_cohort = value
}

export const SET_NOTIFICATION = (state, value) => {
    state.notification = value
}

export const SET_FIELD_LOADING_STATUS = (state, {field, status}) => {
    if (status === true) {
        state.loadings.push(field)
    } else {
        state.loadings = state.loadings.filter(function(v) { return v !== field })
    }
}

export const SET_ANALYSIS_TYPES = (state, {dataset, value}) => {
    state.analyses_types[dataset].all_analysis_types = value
}

export const SET_ANALYSIS_TYPE = (state, {dataset, value}) => {
    state.analyses_types[dataset].analysis_type = value
}

export const SET_DATASET_COHORTS_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].cohorts.all = value
}

export const SET_DATASET_COHORTS_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].cohorts.copy = value
}

export const SET_DATASET_COHORT = (state, {dataset, value}) => {
    state.datasets[dataset].cohorts.selected = value
}

export const SET_DATASET_COHORTS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].cohorts.search = value
}

export const SET_DATASET_SIGNAL_PROVIDERS_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].signal_providers.all = value
}

export const SET_DATASET_SIGNAL_PROVIDERS_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].signal_providers.copy = value
}

export const SET_DATASET_SIGNAL_PROVIDERS = (state, {dataset, value}) => {
    state.datasets[dataset].signal_providers.selected = value
}

export const SET_DATASET_SIGNAL_PROVIDERS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].signal_providers.search = value
}

export const SET_DATASET_SEGMENTS_ALL = (state, {dataset, value}) => {
    if (dataset !== 'cross') {
        state.datasets[dataset].segments.all = value
    }
}

export const SET_DATASET_SEGMENTS_COPY = (state, {dataset, value}) => {
    if (dataset !== 'cross') {
        state.datasets[dataset].segments.copy = value
    }
}

export const SET_DATASET_SEGMENTS = (state, {dataset, value}) => {
    state.datasets[dataset].segments.selected = value
}

export const SET_DATASET_SEGMENTS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].segments.search = value
}

export const SET_DATASET_CATEGORIES_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.categories.all = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.categories.all = value
    } else {
        state.datasets[dataset].categories.all = value
    }
}

export const SET_DATASET_CATEGORIES_COPY = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.categories.copy = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.categories.copy = value
    } else {
        state.datasets[dataset].categories.copy = value
    }
}

export const SET_DATASET_CATEGORIES = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.categories.selected = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.categories.selected = value
    } else {
        state.datasets[dataset].categories.selected = value
    }
}

export const SET_DATASET_CATEGORIES_SEARCH = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.categories.search = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.categories.search = value
    } else {
        state.datasets[dataset].categories.search = value
    }
}

export const SET_DATASET_BRANDS_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.brands.all = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.brands.all = value
    } else {
        state.datasets[dataset].brands.all = value
    }
}

export const SET_DATASET_BRANDS_COPY = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.brands.copy = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.brands.copy = value
    } else {
        state.datasets[dataset].brands.copy = value
    }
}

export const SET_DATASET_BRANDS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.brands.selected = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.brands.selected = value
    } else {
        state.datasets[dataset].brands.selected = value
    }
}

export const SET_DATASET_BRANDS_SEARCH = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.brands.search = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.brands.search = value
    } else {
        state.datasets[dataset].brands.search = value
    }
}

export const SET_DATASET_APPS_CATEGORIES_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].apps_categories.all = value
}

export const SET_DATASET_APPS_CATEGORIES_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].apps_categories.copy = value
}

export const SET_DATASET_APPS_CATEGORIES = (state, {dataset, value}) => {
    state.datasets[dataset].apps_categories.selected = value
}

export const SET_DATASET_APPS_CATEGORIES_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].apps_categories.search = value
}

export const SET_DATASET_APPS_TAGS_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].apps_tags.all = value
}

export const SET_DATASET_APPS_TAGS_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].apps_tags.copy = value
}

export const SET_DATASET_APPS_TAGS = (state, {dataset, value}) => {
    state.datasets[dataset].apps_tags.selected = value
}

export const SET_DATASET_APPS_TAGS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].apps_tags.search = value
}

export const SET_DATASET_APPS_NAMES_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].apps_names.all = value
}

export const SET_DATASET_APPS_NAMES_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].apps_names.copy = value
}

export const SET_DATASET_APPS_NAMES = (state, {dataset, value}) => {
    state.datasets[dataset].apps_names.selected = value
}

export const SET_DATASET_APPS_NAMES_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].apps_names.search = value
}

export const SET_DATASET_APPS_BUNDLEIDS_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.all = value
}

export const SET_DATASET_APPS_BUNDLEIDS_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.copy = value
}

export const SET_DATASET_APPS_BUNDLEIDS = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.selected = value
}

export const SET_DATASET_APPS_BUNDLEIDS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.search = value
}

export const SET_DATASET_APPS_BUNDLEIDS_ALL_IDS = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.all_ids = value
}

export const SET_DATASET_APPS_BUNDLEIDS_IDS = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.ids = value
}

export const SET_DATASET_APPS_BUNDLEIDS_CONCATENATED = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.concatenated = value
}

export const SET_DATASET_APPS_BUNDLEIDS_INSERT_CUSTOM = (state, {dataset, value}) => {
    state.datasets[dataset].apps_bundleids.insert_custom = value
}

export const SET_DATASET_APPS_OS_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].apps_os.all = value
}

export const SET_DATASET_APPS_OS_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].apps_os.copy = value
}

export const SET_DATASET_APPS_OS = (state, {dataset, value}) => {
    state.datasets[dataset].apps_os.selected = value
}

export const SET_DATASET_APPS_OS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].apps_os.search = value
}

export const SET_DATASET_LOCATIONS_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.all = value
    } else {
        state.datasets[dataset].locations.all = value
    }
}

export const SET_DATASET_LOCATIONS_COPY = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.copy = value
    } else {
        state.datasets[dataset].locations.copy = value
    }
}

export const SET_DATASET_LOCATIONS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.selected = value
    } else {
        state.datasets[dataset].locations.selected = value
    }
}

export const SET_DATASET_LOCATIONS_SEARCH = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.search = value
    } else {
        state.datasets[dataset].locations.search = value
    }
}

export const SET_DATASET_LOCATIONS_ALL_IDS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.all_ids = value
    } else {
        state.datasets[dataset].locations.all_ids = value
    }
}

export const SET_DATASET_LOCATIONS_IDS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.ids = value
    } else {
        state.datasets[dataset].locations.ids = value
    }
}

export const SET_DATASET_LOCATIONS_CONCATENATED = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.concatenated = value
    } else {
        state.datasets[dataset].locations.concatenated = value
    }
}

export const SET_DATASET_LOCATIONS_INSERT_CUSTOM = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.locations.insert_custom = value
    } else {
        state.datasets[dataset].locations.insert_custom = value
    }
}

export const SET_DATASET_COUNTRIES_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.countries.all = value
    } else {
        state.datasets[dataset].countries.all = value
    }
}

export const SET_DATASET_COUNTRIES_COPY = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.countries.copy = value
    } else {
        state.datasets[dataset].countries.copy = value
    }
}

export const SET_DATASET_COUNTRIES = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.countries.selected = value
    } else {
        state.datasets[dataset].countries.selected = value
    }
}

export const SET_DATASET_COUNTRIES_SEARCH = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.countries.search = value
    } else {
        state.datasets[dataset].countries.search = value
    }
}

export const SET_DATASET_STATES_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.states.all = value
    } else {
        state.datasets[dataset].states.all = value
    }
}

export const SET_DATASET_STATES_COPY = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.states.copy = value
    } else {
        state.datasets[dataset].states.copy = value
    }
}

export const SET_DATASET_STATES = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.states.selected = value
    } else {
        state.datasets[dataset].states.selected = value
    }
}

export const SET_DATASET_STATES_SEARCH = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.states.search = value
    } else {
        state.datasets[dataset].states.search = value
    }
}

export const SET_DATASET_DMAS_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.dmas.all = value
    } else {
        state.datasets[dataset].dmas.all = value
    }
}

export const SET_DATASET_DMAS_COPY = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.dmas.copy = value
    } else {
        state.datasets[dataset].dmas.copy = value
    }
}

export const SET_DATASET_DMAS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.dmas.selected = value
    } else {
        state.datasets[dataset].dmas.selected = value
    }
}

export const SET_DATASET_DMAS_SEARCH = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.dmas.search = value
    } else {
        state.datasets[dataset].dmas.search = value
    }
}

export const SET_DATASET_CITIES_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.cities.all = value
    } else {
        state.datasets[dataset].cities.all = value
    }
}

export const SET_DATASET_CITIES_COPY = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.cities.copy = value
    } else {
        state.datasets[dataset].cities.copy = value
    }
}

export const SET_DATASET_CITIES = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.cities.selected = value
    } else {
        state.datasets[dataset].cities.selected = value
    }
}

export const SET_DATASET_CITIES_SEARCH = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.cities.search = value
    } else {
        state.datasets[dataset].cities.search = value
    }
}

export const SET_DATASET_ZIP_CODES = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.zip_codes = value
    } else {
        state.datasets[dataset].zip_codes = value
    }
}

export const SET_DATASET_COMPETITORS_CATEGORIES_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.categories.all = value
}

export const SET_DATASET_COMPETITORS_CATEGORIES_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.categories.copy = value
}

export const SET_DATASET_COMPETITORS_CATEGORIES_SELECTED = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.categories.selected = value
}

export const SET_DATASET_COMPETITORS_CATEGORIES_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.categories.search = value
}

export const SET_DATASET_COMPETITORS_BRANDS_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.brands.all = value
}

export const SET_DATASET_COMPETITORS_BRANDS_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.brands.copy = value
}

export const SET_DATASET_COMPETITORS_BRANDS_SELECTED = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.brands.selected = value
}

export const SET_DATASET_COMPETITORS_BRANDS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.brands.search = value
}

export const SET_DATASET_COMPETITORS_LOCATIONS_ALL = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.locations.all = value
}

export const SET_DATASET_COMPETITORS_LOCATIONS_COPY = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.locations.copy = value
}

export const SET_DATASET_COMPETITORS_LOCATIONS_SELECTED = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.locations.selected = value
}

export const SET_DATASET_COMPETITORS_LOCATIONS_SEARCH = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.locations.search = value
}

export const SET_DATASET_COMPETITORS_DISTANCE = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.distance = value
}

export const SET_DATASET_COMPETITORS_UNIT = (state, {dataset, value}) => {
    state.datasets[dataset].competitors.unit = value
}

export const SET_RECENCY_START = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.recency.start_date = value
    } else {
        state.datasets[dataset].recency.start_date = value
    }
}

export const SET_RECENCY_END = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.recency.end_date = value
    } else {
        state.datasets[dataset].recency.end_date = value
    }
}

export const SET_LIMITS_STATUS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.limits.status = value
    } else {
        state.datasets[dataset].limits.status = value
    }
}

export const SET_LIMITS_TIME_STATUS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.limits.time.status = value
    } else {
        state.datasets[dataset].limits.time.status = value
    }
}

export const SET_LIMITS_TIME = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.limits.time.limits = value
    } else {
        state.datasets[dataset].limits.time.limits = value
    }
}

export const SET_LIMITS_DISTANCE_STATUS = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.limits.distance.status = value
    } else {
        state.datasets[dataset].limits.distance.status = value
    }
}

export const SET_LIMITS_DISTANCE = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.limits.distance.limit = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.distance = value
    } else {
        state.datasets[dataset].limits.distance.limit = value
    }
}

export const SET_LIMITS_DISTANCE_UNIT = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.limits.distance.unit = value
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        state.datasets[comp_dataset_id].competitors.unit = value
    } else {
        state.datasets[dataset].limits.distance.unit = value
    }
}

export const SET_FILTERS_ALL = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.filters.all = value
    } else {
        state.filters.all = value
    }
}

export const SET_FILTERS_SELECTED = (state, {dataset, value}) => {
    if (dataset === 'cross') {
        state.analyses.cross_visitation.filters.selected = value
    } else {
        state.filters.selected = value
    }
}

export const SET_ANALYSES_STATUS = (state, {analysis, value}) => {
    state.analyses[analysis].status = value
}

export const SET_ANALYSES_CROSS_VISITATION_POI_LOCATION_LEVEL = (state, value) => {
    state.analyses.cross_visitation.poi_location_level = value
}

export const SET_ANALYSES_FREQUENCY_DAY_PART = (state, value) => {
    state.analyses.frequency.day_part = value
}

export const SET_SCHEDULER_STEP = (state, value) => {
    state.scheduler.step = value
}

export const SET_SCHEDULER_AUDIENCE_TYPE = (state, value) => {
    state.scheduler.audience_type = value
}

export const SET_SCHEDULER_ALL_AUDIENCES = (state, value) => {
    state.scheduler.audiences = value
}

export const SET_SCHEDULER_SELECTED_AUDIENCE = (state, value) => {
    state.scheduler.selected_audience_id = value
}

export const SET_SCHEDULER_START_DATE = (state, value) => {
    state.scheduler.start_date = value
}

export const SET_SCHEDULER_END_DATE = (state, value) => {
    state.scheduler.end_date = value
}

export const SET_SCHEDULER_FULL_TIME = (state, value) => {
    state.scheduler.full_time = value
}

export const SET_SCHEDULER_TIME = (state, value) => {
    state.scheduler.time = value
}

export const SET_SCHEDULER_MESSAGE = (state, value) => {
    state.scheduler.message = value
}

export const SET_SCHEDULER_ACTIVATION_FREQUENCY = (state, value) => {
    state.scheduler.act_frequency = value
}

export const SET_SCHEDULER_RECURRENCE_TYPE = (state, value) => {
    state.scheduler.recurrence_type = value
}

export const SET_SCHEDULER_PERIOD = (state, value) => {
    state.scheduler.period = value
}

export const SET_SCHEDULER_ENDING_TYPE = (state, value) => {
    state.scheduler.ending_type = value
}

export const SET_SCHEDULER_ENDING_RECURRENCES = (state, value) => {
    state.scheduler.ending_after_recurrences = value
}

export const SET_SCHEDULER_AUTO_ACTIVATE_STATUS = (state, value) => {
    state.scheduler.auto_activate = value
}

export const SET_SCHEDULER_TIME_ZONE = (state, value) => {
    state.scheduler.time_zone = value
}

export const SET_ANONYMIZED_FIELDS = (state, {dataset, value}) => {
    state.datasets[dataset].anonymized_fields = value
}

export const SET_DATASET_ANONYMIZED_DATA_ALL = (state, {dataset, field, value}) => {
    state.datasets[dataset].anonymized[field].all = value
}

export const SET_DATASET_ANONYMIZED_DATA_COPY = (state, {dataset, field, value}) => {
    state.datasets[dataset].anonymized[field].copy = value
}

export const SET_DATASET_ANONYMIZED_DATA = (state, {dataset, field, value}) => {
    state.datasets[dataset].anonymized[field].selected = value
}

export const SET_DATASET_ANONYMIZED_DATA_SEARCH = (state, {dataset, field, value}) => {
    state.datasets[dataset].anonymized[field].search = value
}